<template>
  <div class="date-component">
    <div class="date-wrapper inline-block">
      <div class="mr-10 inline-block ">
        {{ $t('text.chart_date') }}
      </div>
      <el-date-picker
        v-model="date"
        type="datetimerange"
        format="dd/MM/yy HH:mm:ss"
        value-format="yyyy-MM-dd HH:mm:ss"
        range-separator="to"
        :start-placeholder="$t('text.start_time')"
        :end-placeholder="$t('text.end_time')"
        :clearable="false"
        :unlink-panels="true"
        popper-class="public-date-poper"
        @change="handleChange()"
        size="small"
      >
      </el-date-picker>
    </div>
    <UtcOffsets />
  </div>
</template>

<script>
import UtcOffsets from '@/components/UtcOffsets'
export default {
  data() {
    return {
      date: this.$store.state.pods.selectedDate
    }
  },
  components: {
    UtcOffsets
  },
  watch: {
    '$store.state.pods.selectedDate': function() {
      this.date = this.$store.state.pods.selectedDate
    }
  },
  methods: {
    handleChange() {
      this.$store.commit('pods/SET_SELECTED_DATE', this.date)
    }
  }
}
</script>
